export async function copyToClipBoard(content: string, dom?: Node) {
  if ('clipboard' in navigator) {
    // 本地和线上环境调用
    await navigator.clipboard.writeText(content);
  } else {
    // http环境（如测试环境）调用
    const a = document.createElement('input');
    a.setAttribute('value', content);
    dom ? dom.appendChild(a) : document.body.appendChild(a);
    a.select();
    document.execCommand('copy');
    dom ? dom.removeChild(a) : document.body.removeChild(a);
  }
}

export async function getClipBoard(readRaw: true, dom?: Node): Promise<ClipboardItems | undefined>;
export async function getClipBoard(readRaw: false, dom?: Node): Promise<string | undefined>;
export async function getClipBoard(readRaw: boolean, dom?: Node) {
  if ('clipboard' in navigator) {
    // 本地和线上环境调用
    try {
      return readRaw ? navigator.clipboard.read() : navigator.clipboard.readText();
    } catch (error) {
      console.error('Failed to read clipboard contents: ', error);
    }
  } else {
    // http环境（如测试环境）调用
    // const a = document.createElement('input');
    // dom ? dom.appendChild(a) : document.body.appendChild(a);
    // a.select();
    // const ok = document.execCommand('paste');
    // if (!ok) {
    //   console.warn("粘贴失败，浏览器不支持document.execCommand('paste')");
    // }
    // const res = a.getAttribute('value') || '';
    // dom ? dom.removeChild(a) : document.body.removeChild(a);
    // return res;
    // chrome无法生效，见https://stackoverflow.com/a/53448633/19566361
    // 直接返回undefined通知外层函数改用从store读取
    return undefined;
  }
}
